module.exports = __webpack_public_path__ + "img/exit-full-screen.39d6a608.svg";